const translations = {
  common: {
    additionalInfo: 'Lisätietoa',
    hours: 'tuntia',
    missing: 'Puuttuu',
    notPresent: 'Ei ole',
    copySuccess: 'Sisältö kopioitu leikepöydälle: {{content}}',
    sender: 'Lähettäjä',
    dateShort: 'Pvm',
    facultyShort: 'TDK',
    faculty: 'Tiedekunta',
    programme: 'Koulutusohjelma',
    addresses: 'Osoitteet',
    contractRequestStatus: 'Pyynnön tila',
    loading: 'Ladataan...',
    dontKnow: 'En tiedä',
    contractRequest: 'Työsopimuspyyntö',
    fieldName: 'Kentän nimi',
    fieldValue: 'Arvo',
    clickToCopy: 'Klikkaa riviä kopioidaksesi kentän arvo',
    message: 'Viesti',
    add: 'Lisää',
    added: 'Lisätty',
    removed: 'Poistettu',
    unknownError: 'Jotain meni pieleen :(',
    details: 'Tarkemmat tiedot',
    goBack: 'Takaisin',
    test: 'Testi',
    exceptions: 'Poikkeukset',
  },
  navbar: {
    description: '– TYÖKALU ULKOPUOLISTEN TUNTIOPETTAJIEN TYÖAIKOJEN JA PALKKIOIDEN LASKEMISEEN',
    signin: 'Kirjaudu',
    signout: 'Kirjaudu ulos',
    frontPage: 'Etusivu',
    contractRequests: 'Työsopimuspyynnöt',
    handlerAddresses: 'Kohdennusosoitteet',
    admin: 'Admin',
  },
  ingress: {
    title: 'Tervetuloa Toppiin!',
    text: `Tämä laskuri on tarkoitettu Helsingin yliopistolle tuntiopetusta pitämään tulevien opettajien palkkioiden laskemista varten. Helsingin yliopistolla on määritetty yleiset periaatteet, miten tuntiopetuksen laskennallinen työaika määräytyy ja minkä suuruisia tuntiperusteisia palkkioita tuntiopetuksesta opettajalle maksetaan.
 
    Laskurilla opettaja voi selvittää, kuinka suuri palkkio hänelle yleisten periaatteiden mukaan maksettaisiin erilaisista tuntiopetuskokonaisuuksista. Laskennalliseen työaikaan vaikuttavat opetustuntien määrä, opetuksen valmisteluun käytetty aika (kurssin tyyppi ja opintopisteet) sekä opiskelijoiden ohjaukseen ja arviointiin käytetty aika (suunniteltu opiskelijoiden määrä). Näiden tietojen perusteella tuntiopetukselle määritetään laskennallinen työaika ja laskennallisilta työtunneilta maksetaan opettajan pätevyyden mukaan määräytyvä tuntipalkkio.
     
    Syöttämällä kurssin tiedot työaikalaskuriin opettaja voi selvittää kuinka monelta tunnilta palkkio maksettaisiin. Palkkiolaskurilla opettaja voi laskea koko kurssilta maksettavan kokonaispalkkion.
     
    Mikäli olet jo sopinut kurssin pitämisestä ja työstäsi on tarkoitus tehdä työsopimus, voit alla olevalla työsopimuspyyntölomakkeella täyttää työsopimusta varten tarvittavat tiedot. Täyttämällä lomakkeen tiedot huolellisesti nopeutat työsopimuksen valmistelua. Jos olette esihenkilön kanssa erikseen sopineet poikkeuksista yleisistä palkkionmääräytymisperiaatteista, kirjaathan ne alla oleviin asianomaisiin kenttiin. HUOM! Työsopimuspyyntölomake ei ole vielä lopullinen työsopimus vaan sinuun ollaan erikseen yhteydessä, kun lopullinen työsopimus on valmisteltu ja se tulee osapuolten allekirjoitettavaksi.`,
  },
  status: {
    waiting: 'Odottaa',
    handled: 'Käsitelty',
    rejected: 'Hylätty',
  },
  errors: {
    required: 'Tämä kenttä on pakollinen',
    mustBeBefore: 'On oltava lopetuspäivämäärää ennen',
    mustBeAfter: 'On oltava aloituspäivämäärän jälkeen',
  },
  setStatusAction: {
    waiting: 'Merkkaa odottavaksi',
    handled: 'Merkkaa käsitellyksi',
    rejected: 'Merkkaa hylätyksi',
  },
  courseType: {
    recurring: 'Toistuva',
    refresh: 'Uudistettava',
    new: 'Uusi',
  },
  calculatorFields: {
    teachingHours: 'Opetustunnit',
    courseType: 'Kurssin tyyppi',
    credits: 'Opintopisteet',
    preparationHours: 'Valmistelutunnit',
    studentCount: 'Opiskelijoiden määrä',
    studentCountWorkingHours: 'Opiskelijoiden määrään perustuva lisätyöaika',
    totalWorkingHours: 'Työaika yhteensä',
    workHourExceptions: 'Työaikaan vaikuttavat poikkeukset',
    hourlyRate: 'Tuntipalkka',
    totalSalary: 'Palkkio yhteensä',
    salaryExceptions: 'Palkkioon vaikuttavat poikkeukset',
  },
  calculator: {
    teachingHoursTitle: 'Opetustuntien määrä',
    teachingHoursDescription: 'Määritetty usein opetusohjelmassa. Tarvittaessa koulutusohjelman johtaja tai johtoryhmä päättää. Esim. 5 op kurssilla tyypillisesti 20-25.',
    preparation: 'Kurssin valmistelu',
    creditsDescription: 'Määräytyy OPS:n mukaan. Tyypillisesti 5 op. kursseja.',
    studentCountTitle: 'Suunniteltu opiskelijoiden määrä',
    studentCountDescription: 'Määritetty usein opetusohjelmassa. Tarvittaessa koulutusohjelman johtaja tai johtoryhmä päättää.',
    courseTypeDescription: 'Yleensä kurssit uudistettavia. Koulutusohjelman johtaja päättää.',
    preparationTableInfo: 'Kurssiin valmistautumiseen käytettävä työaika lasketaan seuraavan taulukon mukaisesti:',
    qualification: 'Vaativuus / Pätevyys',
    salary: 'Palkkio',
    hourlyRate: 'Tuntipalkka',
    hourlyRateTitle: 'Tuntipalkka',
    hourlyRateDescription: 'Merkitse vaatimustason mukainen tuntipalkkasi',
    salaryTableTitle: 'Helsingin yliopiston yleisen taulukon mukaiset palkkiot ulkopuolisille opettajille:',
    totalSalary: 'Palkkio yhteensä',
    workHourCalculator: 'Työaikalaskuri',
    salaryCalculator: 'Palkkalaskuri',
    salaryExceptions: 'Palkkioon vaikuttavat poikkeukset',
    workHourExceptions: 'Työaikaan vaikuttavat poikkeukset',
  },
  salaryTableData: {
    levelA: 'Taso A. Vaativuustaso 8-11 (esim. professori)',
    levelB: 'Taso B. Vaativuustaso 7 (esim. dosentti)',
    levelC: 'Taso C. Vaativuustaso 5-6 (esim. tohtori)',
    levelD: 'Taso D. Vaativuustaso 4 (esim. lisensiaatti tai ylempi korkeakoulututkinto)',
    levelE: 'Taso E. Alempi korkeakoulututkinto (esim. opetusavustaja)',
    levelF: 'Taso F. Muut',
  },
  contractRequestForm: {
    title: 'Työsopimuspyyntö',
    formTitle: 'Työsopimusta varten tarvittavat muut tiedot',
    courseOrganiser: 'Kurssin järjestäjä',
    chooseFaculty: 'Valitse tiedekunta',
    chooseProgramme: 'Valitse koulutusohjelma',
    courseSchedule: 'Kurssin aikataulu',
    startDatelabel: 'Ensimmäinen luento',
    endDatelabel: 'Viimeinen luento/tentti',
    contractDates: 'Sopimuksen kesto',
    contractDatesRecommended: 'Suositeltu: alkaa viikkoa ennen kurssin alkua ja jatkuu kaksi viikkoa sen loputtua',
    contractDatesInfo:
      'Sopimuksen päivämäärät ovat palkanmaksua varten, mutta eivät estä sitä että esim. kurssin valmisteluun käytetään aikaa jo ennen sopimuksen alkua tai kokeiden tarkastamiseen sopimuksen loputtua.',
    contractDatesCustom: 'Muu aikaväli',
    chooseStartDate: 'Valitse alkupäivä',
    chooseEndDate: 'Valitse loppupäivä',
    recommendedStartDate: 'Suositeltu alkupäivä',
    recommendedEndDate: 'Suositeltu loppupäivä',
    calculatorPreviewTitle: 'Työaika ja palkka',
    calculatorPreviewDescription: 'Täyttämäsi laskurin tiedot lähetetään työsopimuspyynnön mukana. Tarkistathan vielä niiden oikeellisuuden.',
    additionalInfoPretext: 'Kerro tässä esimerkiksi sovituista poikkeuksista',
    beginSubmission: 'Aloita lähetys',
    submitLoading: 'Lähetetään työsopimuspyyntöä...',
    submitSuccess: 'Työsopimuspyyntö lähetetty onnistuneesti',
    submitError: 'Työsopimuspyynnön lähettäminen epäonnistui',
    submit: 'Lähetä käsiteltäväksi',
    testInfo: 'Kuulut Topin henkilökuntaan, joten lähettämäsi pyyntö merkitään testiksi.',
  },
  contractRequestPreview: {
    title: 'Työsopimuspyynnön esikatselu',
    description: 'Tarkista vielä syöttämäsi työsopimuspyynnön tiedot ennen lähetystä.',
    formFieldsSection: 'Henkilötiedot ja kurssin muut tiedot',
  },
  formFields: {
    firstName: 'Etunimi',
    lastName: 'Sukunimi',
    email: 'Sähköposti',
    birthDate: 'Syntymäaika',
    courseStartDate: 'Kurssin alkupäivä',
    courseEndDate: 'Kurssin loppupäivä',
    contractStartDate: 'Sopimuksen alkupäivä',
    contractEndDate: 'Sopimuksen loppupäivä',
    courseName: 'Kurssin nimi',
    additionalInfos: 'Lisätiedot',
    recommendedContractDuration: 'Suositeltu',
    customContractDuration: 'Itse merkattu',
  },
  contractRequestView: {
    calculatorFields: 'Laskuriin merkatut tiedot',
    noHandlers: 'Pyynnöllä ei käsittelijöitä. Joko pyynnön tiedekunta-kenttä puuttuu, tai tiedekunnalle ei ole vielä merkattu käsittelijöitä.',
    contractHandlerAddresses: 'Pyynnön käsittelyosoitteet',
    updateStatus: 'Päivitä pyynnön tila',
    updateStatusInstructions:
      'Jos pyyntö on nyt käsitelty, merkkaa se valmiiksi. Jos tiedoissa on jotain korjattavaa, merkkaa se korjattavaksi. Pyynnön lähettäjä saa sähköpostiinsa ilmoituksen pyynnön tilan muutoksesta.',
    messageDescription: 'Vapaamuotoinen viesti pyynnön tilan päivitykseen',
    testInfo: 'Tämä pyyntö on testi, sitä ei tarvitse käsitellä. Testipyynnöstä lähtee ilmoitus erikseen valittuun testikohdennusosoitteeseen.',
  },
  handlerAddresses: {
    newAddress: 'Uusi käsittelijän osoite/IAM',
    removeConfirm: 'Haluatko varmasti poistaa osoitteen {{address}} tiedekunnan {{facultyCode}} käsittelijöistä?',
  },
} as const

export default translations
